/**
 * One CSV cell, as a spreadsheet will read it.
 *
 * Two jobs. The first is CSV's own: a value holding a comma, a quote or a line break is
 * quoted, and its quotes doubled.
 *
 * The second is the spreadsheet's. Excel, Numbers and Sheets all read a cell that starts
 * with = + - or @ as a formula, and an export is full of text other people typed — donor
 * names, partner names, prayer requests. A donor recorded as `=HYPERLINK("…","Click")`
 * becomes a working link in the file somebody opens to plan a mailing, and a few formulas
 * can do worse. A leading apostrophe is the convention every one of them reads as "this is
 * text", and it is not shown in the cell.
 *
 * A value that is a plain number is left alone, even with a sign in front, so a negative
 * figure is still a figure. A phone number like "+44 20 7946 0000" is not a plain number,
 * so it gets the apostrophe, which also stops a spreadsheet from mangling it.
 */
const FORMULA_START = /^[=+\-@\t\r]/
const PLAIN_NUMBER = /^[+-]?\d+(\.\d+)?$/

export function csvCell(v) {
  let s = v === null || v === undefined ? '' : String(v)
  if (FORMULA_START.test(s) && !PLAIN_NUMBER.test(s)) s = `'${s}`
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}
